// "use client"
import { useState, useEffect } from 'react';

const Alert = ({ message, state, callback }) => {
  // console.log('alert state', state)
  // console.log('message', message)



  useEffect(() => {
    // Only set the timeout if there's something to close (i.e., success or error message is visible)
    if (state.success || state.error) {
      let timer = setTimeout(() => { handleClose(); }, 4000);
      // Cleanup timeout on component unmount or if state changes before the timeout completes
      return () => clearTimeout(timer);
    }

    // This effect depends on state.success and state.error, so include them in the dependency array
  }, [state.success, state.error, state.hint]); // Add state.success and state.error to the dependency array
  

  

  const handleClose = () => {
    // callback({action: "alertControl", success: false, error:false})
    state.setSuccess(false);
    state.setError(false);

  };


  return (
    <>

     {/* <div className="ml-14 flex justify-center items-center"> */}
    <div className="flex justify-center items-center">

     {/* <div
       className={`fixed text-sm rounded-l-xl shadow-xl z-50 bottom-3 right-0 w-3/5 md:w-2/4 lg:w-[400px] p-4 font-medium dark:bg-gray-900 border-gray-400 dark:border-gray-700 transition-transform duration-300 transform 
        ${state.success ? 'bg-green-50' : state.error ? 'bg-red-50' : 'bg-gray-50'}  
        ${state.success ? 'text-green-800 dark:text-green-500' : state.error ? 'text-red-800 dark:text-red-500' : 'text-black dark:text-white'} 
        ${state.success || state.error ? 'translate-y-0 opacity-1' : 'translate-y-full opacity-0'} `}
     > */}

      <div
       className={`fixed text-sm rounded-l-xl shadow-xl z-50 bottom-3 right-0 w-3/5 md:w-2/4 lg:w-[400px] p-4 font-medium dark:bg-gray-900 border-gray-400 dark:border-gray-700 transition-transform duration-300 transform 
        ${state.success ? 'bg-green-50' : state.error ? 'bg-red-50' : 'bg-gray-50'}  
        ${state.success ? 'text-green-800 dark:text-green-500' : state.error ? 'text-red-800 dark:text-red-500' : 'text-black dark:text-white'} 
        ${state.success || state.error ? 'translate-y-0 opacity-1' : 'translate-y-full opacity-0'} `}
     >



       <div className="flex justify-between items-center">
         <p>
         {state.error && <i className="fa-solid fa-circle-exclamation pr-2"></i>}
         {state.success && <i className="fa-solid fa-circle-check pr-2"></i>}
          {message}
          </p>
         {/* <button onClick={()=>{handleClose()}} className="text-sm">
           Close
         </button> */}


      <button onClick={()=>{handleClose()}} type="button" className={`transition duration-300 ease-in-out ml-auto -mx-1.5 -my-1.5 ${state.success ? 'bg-green-100 hover:bg-green-200 text-green-500 dark:text-green-400 focus:ring-green-400' : state.error ? 'bg-red-100 hover:bg-red-200 text-red-500 dark:text-red-400 focus:ring-red-400' : 'bg-gray-100 hover:bg-gray-200 text-gray-500 dark:text-gray-400 focus:ring-gray-400'} rounded-lg focus:ring-2 p-1.5 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:hover:bg-gray-700`} data-dismiss-target="#alert-2" aria-label="Close">
          <span className="sr-only">Close</span>
          <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
        </button>


       </div>
     </div>
   </div>
</>
  );
};

export default Alert;